import type { SetValueConfig, UseFormSetValue } from "react-hook-form";
import type { ReminderFormModel } from "web_myplann/Reminders/Forms/reminderFormSchema";

export const applyReminderTemplateFormValues = (
	setValue: UseFormSetValue<ReminderFormModel>,
	values: Partial<ReminderFormModel>,
	options: SetValueConfig,
) => {
	if (values.name !== undefined) {
		setValue("name", values.name, options);
	}
	if (values.recurrence !== undefined) {
		setValue("recurrence", values.recurrence, options);
	}
	if (values.date !== undefined) {
		setValue("date", values.date, options);
	}
	if (values.typeKey !== undefined) {
		setValue("typeKey", values.typeKey, options);
	}
};
